import type {
  RouterTabPath,
  TabDefinition,
  ValidUiModel,
} from "src/lib/tabs/types.ts";
import type { Router } from "@remix-run/router";
import { matchRoutes } from "react-router-dom";
import { normalizePathname } from "src/lib/tabs/normalizePathname.ts";

export const convertPathsToIdMap = <
  UiModel extends ValidUiModel = ValidUiModel,
>({
  paths,
  config,
  router,
}: {
  config: TabDefinition<UiModel>[];
  router: Router;
  paths: RouterTabPath[];
}) => {
  return paths.reduce(
    (acc, path: RouterTabPath) => {
      const matches = matchRoutes(router.routes, path) || [];

      for (let i = matches.length - 1; i > -1; i--) {
        const match = matches[i];

        if (config.find((def) => def.shouldOpen(match))) {
          return {
            ...acc,
            [normalizePathname(match.pathname)]: path,
          };
        }
      }

      return acc;
    },
    {} as Record<string, RouterTabPath>,
  );
};
